module.exports = __webpack_public_path__ + "img/folder-14.924677f1.png";